<template lang="jade">
	include ../../node_modules/tangram-ui/src/elements/tge-button/tge-button.jade
	include ../../node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle.jade

	.election-component.election-map(:election-embed="embed")

		GroupTitle(v-if="title", :title="titleText", :year="year", :fineprint="percentCounted")
		template(v-if="embed")
			YearNav(@update:changeYear="changeYear", :year="year", :embed="embed")

		.election-component_content.map-group( :class="{ loading: loading, comparison: compareYears }")
			.map-sidebar
				.map-filters(:key="filters.party")
					h4.map-filters_title
						| Filter map by party
						transition(appear, name="fade")
							+tge-button({
								text: 'Clear',
								icon: 'close',
								customAttributes: { '@click': 'filters.party = null', 'v-if': 'filters.party' }
							})
					.map-filters_parties(v-if="parties")
						.map-filters_party(v-for="party in parties", :key="party['code']", :party="party['code']", :class="{ selected: filters.party === party['code'] }")
							input( type="radio", name="filter_party", :id="'filter_party_' + party['code'] + '_' + _uid", :value="party['code']", v-model="filters.party")
							label( :for="'filter_party_' + party['code'] + '_' + _uid")
								span.fullname {{ party['name'] }}
								span.code {{ party['code'] }}

			.map-group_content(v-if="visibleYears", v-for="compareYear in visibleYears", :key="compareYear")
				//h3 {{ compareYear }}
				MapItem(:data="maps.main", :filters="filters", :year="compareYear", :triggerLoad="true")
				MapItem(v-if="insetData", :data="insetData", :filters="filters", :year="compareYear")


			LoadingOverlay(v-if="embed", :loading="loading")
		.election-map_disclaimer.election-fineprint.election-divider
			*&nbsp;Count and electorate colours based on primary vote, not final preference flows


</template>
<script>
// TODO: loop through compare years
	import maps from '@/config';
	import MapItem from './MapItem.vue';
	import LoadingOverlay from './LoadingOverlay.vue'
	import GroupTitle from './GroupTitle.vue';
	import YearNav from './YearNav.vue';

	export default {
		name: "map-group",
		props: {
			insetRegion: {
				type: String
			},
			embed: {
				type: Boolean
			},
			currentYear: {},
			title: {
				type: String
			},
			compareYears: {
				type: Array
			}
		},
		data() {
			return {
				maps,
				filters: {
					party: null
				},
				year: this.currentYear
			}
		},
		computed: {
			insetData: function(){
				return this.maps[this.insetRegion];
			},
			parties: function() {
				return this.$store.getters.parties(this.year);
			},
			loading() { return this.$store.state.loading; },
			titleText() {
				return this.year ? `${this.year}: ${this.title}` : this.title;
			},
			percentCounted() {
				const percentRollCounted = this.$store.getters.percentCounted(this.year);
				return percentRollCounted ? `${percentRollCounted}% counted` : null;
			},
			visibleYears() {
				return this.compareYears || [this.year];
			}/**/
		},
		components: { MapItem, LoadingOverlay, GroupTitle, YearNav },
		methods: {
			changeYear(year) {
				this.year = year;
				this.$store.dispatch('loadMap', year)
				this.$store.dispatch('loadResults', year).then((a, b) => {
					console.log('loadmap promise', a, b)
				})
			}
		}
	}
</script>
<style lang="scss">
@import "src/_commons/assets/scss/global-sass";
@import 'node_modules/tangram-ui/src/elements/tge-button/tge-button';
@import "node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle";
@import "node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle-dependencies";


.election-map {
	flex-basis: 100%;

	&[election-embed] {
		max-width: 650px;
		@include MQ_SmallOnly(){
			padding: 0 $m-spacing-x4;
			margin: $m-spacing-x4 auto;
		}
		.map-group {
			padding: $m-spacing-x3 $m-spacing $m-spacing;
		}
	}

	.tge-componenttitle {
		margin-bottom: $m-spacing;
	}
	/*
	&_disclaimer {
	    border-top: 1px solid rgba(0, 0, 0, 0.2);
	    padding: $m-spacing;
	    margin-top: $m-spacing-x2;
	}*/
}

.map-group {
	position: relative;
	@include MQ_TabletAndUp() {
		display: flex;
		justify-content: center;
		flex-basis: 100%;
	}

	@include MQ_MobileOnly() {
		display: flex;
		flex-direction:column;
	}


}

.map-sidebar {
	display: flex;
	flex-direction: column;
	max-width: 240px;
}



.map-filters {
	@include tgs-font-base-m;
	max-width: 100%;
	position: relative;
	text-align: left;
	padding: $m-spacing #{$m-spacing * 6} $m-spacing $m-spacing;
	z-index: 10;
	@include MQ_DesktopAndUp() {
		padding: $m-spacing #{$m-spacing * 6} $m-spacing $m-spacing;
	}

	@include MQ_MobileTablet {
		padding: $m-spacing $m-spacing #{$m-spacing * 6} $m-spacing;
	}
}
.map-filters_title {
	margin:0 0 $m-spacing; position:relative;
	text-transform: none;
	@include MQ_MobileTablet {
		padding: 0 #{$m-spacing * 6} 0 0;
	}
}
.map-filters_parties {
	display: flex;
	//@include MQ_TabletAndUp() {
		flex-direction: column;
	//}


	justify-content: flex-start;
	align-items: flex-start;
	input { display: none;}


	.map-filters_party {
		padding: 2px 0;
		font-size: 16px;
		line-height: 1.3em;
		width: 100%;
		&.selected {
			font-weight: bold;
		}

		label {
			cursor: pointer;
			padding: 0 $m-spacing;
			border-left: $m-spacing solid;
			display: block;

			@include MQ_TabletAndUp() {
				span.fullname{ display: block; }
				span.code{ display: none; }
			}

			@include MQ_MobileOnly() {
				span.code{ display: block; }
				span.fullname{ display: none; }
			}
			.fullname {
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
		}
		&[party="LNP"] {
			label { border-color: $color-LNP; }
		}
		&[party="ALP"] {
			label { border-color: $color-ALP; }
		}
		&[party="GRN"] {
			label { border-color: $color-GRN; }
		}
		&[party="ZZZ"] {
			label { border-color: $color-IND; }
		}
		&[party="KAP"] {
			label { border-color: $color-KAP; }
		}
		&[party="PUP"] {
			label { border-color: $color-OTH; }
		}
		&[party="ONP"] {
			label { border-color: $color-ONP; }
		}
		&[party="FFP"] {
			label { border-color: $color-FFP; }
		}
	}
}


@include MQ_MobileOnly() {
	.map-sidebar {
		order: 1;
	}
	.map-main {
		order:0;
	}

	.map-filters {
		position: absolute;
	    top: 0;
	    right: 0;
	    width: 42%;
		&_parties {
			flex-wrap: wrap;
			flex-direction: row;
		}
		&_party {
			flex-basis: 50%;
		}
	}
}

@include MQ_TabletAndUp() {
	.map-sidebar {
		flex: 1 0 240px;
	}
	.map-main,
	.map-group_content {
		flex: 2.3 0 0;
		min-width:0;
		position: relative;
	}

	.map-group.comparison .map-group_content {
		flex: 1 0 0;
		flex-basis: 45%;
		padding-top: $m-spacing-x4;
		// padding: 0 $m-spacing-x4;
	}
}

@include MQ_DesktopAndUp() {
	.map-sidebar {
		margin-right: -22%;
	}

	.map-group.comparison .map-sidebar {
		margin-right: -12%;
	}

	.map-inset {
		max-width: 300px;
		width: 35%;
		position: absolute;
		right: $m-spacing;
		top:$m-spacing;
	}
}

@include MQ_TabletOnly() {
	.map-sidebar {
		order:1;
		flex: 1 0 0;
		align-items: center;
		justify-content: space-between;
		min-width:0;
	}
	.map-main {
		flex: 2.3 0 0;
		min-width:0;
	}

	.map-filters {
		order:1;
	}

	.map-inset {
		transform: translateX(-30%);
		max-width: 300px;
		width: 120%;
		padding-top:$m-spacing-x4;
	}
}

.map-filters .tge-button {
	position: absolute;
	margin-left: $m-spacing-x2;
	top: 50%;
	transform: translateY(-50%);

	@include MQ_MobileTablet() {
		right: 0%;
		.tge-button_text { display: none;}
	}
}
</style>



// WEBPACK FOOTER //
// MapGroup.vue?a52dd060